import React, { useMemo, useState } from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";
import BaseDataTable from "./BaseDataTable";

export default function DialogTableContent({
  columns,
  data,
  formFields = [],
  formTitle = "",
  defaultFormValues = {},
  tableProps = {},
  extraContent = null,
}) {
  const initialFormValues = useMemo(() => {
    if (Object.keys(defaultFormValues).length > 0) {
      return defaultFormValues;
    }

    return formFields.reduce((acc, field) => {
      acc[field.name] = field.defaultValue ?? "";
      return acc;
    }, {});
  }, [formFields, defaultFormValues]);

  const [formValues, setFormValues] = useState(initialFormValues);

  const handleFieldChange = (fieldName) => (event) => {
    setFormValues((prev) => ({
      ...prev,
      [fieldName]: event.target.value,
    }));
  };

  return (
    <Box>
      <BaseDataTable columns={columns} data={data} mrtProps={tableProps} />

      {extraContent ? <Box mt={2}>{extraContent}</Box> : null}

      {formFields.length > 0 ? (
        <Box mt={3}>
          {formTitle ? (
            <Typography variant="h6" mb={2}>
              {formTitle}
            </Typography>
          ) : null}

          <Grid container spacing={2}>
            {formFields.map((field) => (
              <Grid item xs={12} md={field.md ?? 6} key={field.name}>
                <TextField
                  fullWidth
                  label={field.label}
                  name={field.name}
                  type={field.type || "text"}
                  value={formValues[field.name] ?? ""}
                  onChange={handleFieldChange(field.name)}
                  placeholder={field.placeholder}
                  multiline={field.multiline}
                  minRows={field.minRows}
                  disabled={field.disabled}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      ) : null}
    </Box>
  );
}
